// extracted by mini-css-extract-plugin
export default {"container":"Eoi_pd","text":"R6sCjW","block":"pTFZ4W"};